import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Image, Tab, Tabs } from "react-bootstrap";
import { useAlert } from "../../../../context/AlertContext";
import { PaperIcon } from "../../../../data/iconImage";
import { getServiceRequest } from "../../../../commons/ServiceRequest";
import Table from "../../../../components/Table";
import SearchFilter from "../../../../components/SearchFilter";
import ReturnService from "../../../../services/return.service";
import CardDisplayComponent from "../../../../components/CardDisplayComponent";

export default function ProductReturnedSuccessfully() {
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState([]);
  const [data, setData] = useState([]);
  const columns = [
    {
      name: "ลำดับ",
      selector: (row) => row.rowIndex,
      sortable: true,
      width: "110px"
    },
    { name: "เลขที่เอกสาร", selector: (row) => row.Return_Doc_No },
    { name: "BP Master", selector: (row) => row.Return_BP_Mas },
    { name: "ชื่อลูกค้า", selector: (row) => row.Return_Cus_Name },
    { name: "เลขที่ DO.", selector: (row) => row.Return_DO_No },
    {
      name: "สถานะ",
      selector: (row) => row.Return_Status,
      conditionalCellStyles: [
        {
          when: (row) => row.Return_Status === "ดำเนินการเรียบร้อย",
          style: { color: "#59B021" }
        },
        {
          when: (row) => row.Return_Status === "ยกเลิก",
          classNames: ["text-danger"]
        }
      ]
    },
    {
      name: "รายละเอียดใบขอเบิก",
      selector: (row) => <Image src={PaperIcon} alt="Paper Icon" />,
      center: true
    }
  ];
  const searchInput = [
    {
      name: "date_from",
      label: "วันที่จาก",
      type: "date",
      classNames: { col: "mb-3", label: "mb-1" }
    },
    {
      name: "date_to",
      label: "วันที่ถึง",
      type: "date",
      classNames: { col: "mb-3", label: "mb-1" }
    },
    {
      name: "Return_Doc_No",
      label: "เลขที่เอกสาร",
      classNames: { col: "mb-3", label: "mb-1" }
    },
    {
      name: "Return_BP_Mas",
      label: "ชื่อลูกค้า (BP Master)",
      classNames: { col: "mb-3", label: "mb-1" }
    }
  ];

  useEffect(() => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: ReturnService.getAllReturns(),
      callback: (response) => setData(response)
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>เบิก/คืนสินค้าสำเร็จ</title>
        <meta
          name="description"
          content="Product Picked up/Returned Successfully Page"
        />
      </Helmet>

      <Container fluid className="p-0">
        <Tabs
          justify
          defaultActiveKey="returned"
          onSelect={(k) =>
            k === "pickedup" && navigate("/archive_view/pickedup")
          }
        >
          <Tab eventKey="pickedup" title="เบิกสินค้าสำเร็จ"></Tab>
          <Tab eventKey="returned" title="คืนสินค้าสำเร็จ">
            <CardDisplayComponent
              body={{
                element: (
                  <SearchFilter
                    data={data}
                    inputField={searchInput}
                    fieldClassName={{
                      inputRow: "justify-content-end align-items-center",
                      actionButton: "pt-2 text-end"
                    }}
                    searchCallback={(search) => setSearchValue(search)}
                  />
                )
              }}
            />

            <CardDisplayComponent
              header={{ title: { text: "คืนสินค้าสำเร็จ" } }}
              body={{
                element: (
                  <Table
                    data={data}
                    column={columns}
                    pending={loading}
                    searchFilter={searchValue}
                    pagination
                  />
                )
              }}
            />
          </Tab>
        </Tabs>
      </Container>
    </>
  );
}
